/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { riskItemEntrySchema } from './riskItemEntrySchema';

export const riskAnalysisSchema = z.object({
  get added() {
    return z.array(riskItemEntrySchema);
  },
  portfolioAtRisk: z.int(),
  get resolved() {
    return z.array(riskItemEntrySchema);
  },
  scenarioAtRisk: z.int(),
});
